import { render, staticRenderFns } from "./newshopRetn.vue?vue&type=template&id=218f0d8c&scoped=true"
import script from "./newshopRetn.vue?vue&type=script&lang=js"
export * from "./newshopRetn.vue?vue&type=script&lang=js"
import style0 from "./newshopRetn.vue?vue&type=style&index=0&id=218f0d8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218f0d8c",
  null
  
)

export default component.exports